<template>
  <v-layout
    fill-height
    v-bind="layoutAttrs"
    class="stepper__header"
  >
    <v-flex
      v-for="(item, index) in content"
      :key="index"
      xs12
      :mb-3="$vuetify.breakpoint.mdAndUp"
    >
      <v-layout>
        <router-link
          :ref="`link-${index}`"
          class="stepper__link small"
          :disabled="index > activeIndex"
          :to="{ name: item.to }"
        >
          {{ item.title }}
        </router-link>
        <v-icon v-if="$vuetify.breakpoint.smAndDown && index < content.length - 1">
          keyboard_arrow_right
        </v-icon>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: 'AddFamilyTOC',
    props: {
        content: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            activeIndex: null
        };
    },
    computed: {
        layoutAttrs () {
            if (this.$vuetify.breakpoint.mdAndUp) {
                return {
                    'align-content-start': true,
                    wrap: true,
                    'px-3': true,
                    'py-3': true
                };
            } else {
                return {
                    'align-center': true,
                    'justify-space-between': true,
                    'mx-2': true,
                    'py-2': true
                };
            }
        }
    },
    mounted () {
        const i = this.content.findIndex((el) => el.to === this.$route.name);
        this.activeIndex = i;
    }
};
</script>

<style scoped></style>
